module.exports = __webpack_public_path__ + "image-43f987f520c6.png";